import React, { useState } from 'react';

// Sample categories data
const initialCategories = [
  { id: 1, name: 'Electronics', status: 'Deactive' },
  { id: 2, name: 'Fashion', status: 'Active' },
  { id: 3, name: 'Home Appliances', status: 'Deactive' },
  { id: 4, name: 'Grocery/Health', status: 'Deactive' },
  { id: 5, name: 'PersonalCare', status: 'Active' },
  { id: 6, name: 'Grocery', status: 'Active' }
];

const CategoryManagement = () => {
  const [categories, setCategories] = useState(initialCategories);
  const [categoryName, setCategoryName] = useState('');
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [status, setStatus] = useState('Deactive');
  const [image, setImage] = useState(null);
  const [isCreateMode, setIsCreateMode] = useState(true);

  const handleImageChange = (e) => {
    setImage(e.target.files[0]);
  };

  const handleCategoryChange = (e) => {
    setCategoryName(e.target.value);
  };

  const handleCancel = () => {
    setCategoryName('');
    setImage(null);
    setStatus('Deactive');
    setSelectedCategory(null);
    setIsCreateMode(true);
  };

  const handleCreateCategory = () => {
    if (categoryName.trim()) {
      const newCategory = {
        id: categories.length + 1,
        name: categoryName,
        status,
        image: image ? image.name : 'No image',
      };
      setCategories([...categories, newCategory]);
      handleCancel();
    }
  };

  const handleUpdateCategory = () => {
    if (categoryName.trim() && selectedCategory) {
      const updatedCategories = categories.map((category) =>
        category.id === selectedCategory.id
          ? { ...category, name: categoryName, status, image: image ? image.name : category.image }
          : category
      );
      setCategories(updatedCategories);
      handleCancel();
    }
  };

  const handleActivateDeactivate = (categoryId) => {
    const updatedCategories = categories.map((category) =>
      category.id === categoryId
        ? { ...category, status: category.status === 'Active' ? 'Deactive' : 'Active' }
        : category
    );
    setCategories(updatedCategories);
  };

  const handleSelectCategory = (category) => {
    setSelectedCategory(category);
    setCategoryName(category.name);
    setStatus(category.status);
    setIsCreateMode(false);
  };

  return (
    <div style={containerStyle}>
      <h1 style={headerStyle}>{isCreateMode ? 'Create Category' : 'Update Category'}</h1>
      
      {/* Category Form */}
      <div style={formContainerStyle}>
        <div style={inputGroupStyle}>
          <label style={labelStyle}>Category Name</label>
          <input
            type="text"
            value={categoryName}
            onChange={handleCategoryChange}
            placeholder="Enter Category Name"
            style={inputStyle}
          />
        </div>
        
        <div style={inputGroupStyle}>
          <label style={labelStyle}>Upload Image</label>
          <input
            type="file"
            onChange={handleImageChange}
            style={inputStyle}
          />
          <span style={fileNameStyle}>{image ? image.name : 'No file chosen'}</span>
        </div>
        
        <div style={inputGroupStyle}>
          <label style={labelStyle}>Status</label>
          <select
            value={status}
            onChange={(e) => setStatus(e.target.value)}
            style={selectStyle}
          >
            <option value="Active">Active</option>
            <option value="Deactive">Deactive</option>
          </select>
        </div>
        
        <div style={buttonContainerStyle}>
          <button
            onClick={isCreateMode ? handleCreateCategory : handleUpdateCategory}
            style={actionButtonStyle}
          >
            {isCreateMode ? 'Create Category' : 'Update Category'}
          </button>
          <button
            onClick={handleCancel}
            style={cancelButtonStyle}
          >
            Cancel
          </button>
        </div>
      </div>
      
      {/* Category List */}
      <h2 style={listHeaderStyle}>Category List</h2>
      <table style={tableStyle}>
        <thead>
          <tr>
            <th style={tableHeaderStyle}>Sr. No.</th>
            <th style={tableHeaderStyle}>Category Name</th>
            <th style={tableHeaderStyle}>Image</th>
            <th style={tableHeaderStyle}>Status</th>
            <th style={tableHeaderStyle}>Action</th>
          </tr>
        </thead>
        <tbody>
          {categories.map((category, index) => (
            <tr key={category.id} style={tableRowStyle}>
              <td style={tableCellStyle}>{index + 1}</td>
              <td style={tableCellStyle}>{category.name}</td>
              <td style={tableCellStyle}>{category.image}</td>
              <td style={tableCellStyle}>{category.status}</td>
              <td style={tableCellStyle}>
                <button
                  onClick={() => handleSelectCategory(category)}
                  style={updateButtonStyle}
                >
                  Update
                </button>
                <button
                  onClick={() => handleActivateDeactivate(category.id)}
                  style={category.status === 'Active' ? deactivateButtonStyle : activateButtonStyle}
                >
                  {category.status === 'Active' ? 'Deactivate' : 'Activate'}
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

// Styles for the UI
const containerStyle = {
  fontFamily: 'Arial, sans-serif',
  padding: '20px',
  backgroundColor: '#f5f5f5',
  borderRadius: '8px',
  maxWidth: '1200px',
  margin: '0 auto',
};

const headerStyle = {
  textAlign: 'center',
  fontSize: '24px',
  color: '#333',
};

const formContainerStyle = {
  backgroundColor: '#fff',
  padding: '20px',
  borderRadius: '8px',
  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
  marginBottom: '40px',
};

const inputGroupStyle = {
  marginBottom: '15px',
};

const labelStyle = {
  fontSize: '14px',
  marginBottom: '5px',
  display: 'block',
};

const inputStyle = {
  width: '100%',
  padding: '10px',
  fontSize: '14px',
  borderRadius: '4px',
  border: '1px solid #ddd',
};

const fileNameStyle = {
  marginLeft: '10px',
  fontSize: '12px',
  color: '#666',
};

const selectStyle = {
  padding: '10px',
  fontSize: '14px',
  borderRadius: '4px',
  border: '1px solid #ddd',
};

const buttonContainerStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  marginTop: '20px',
};

const actionButtonStyle = {
  backgroundColor: '#007bff',
  color: 'white',
  padding: '10px 20px',
  fontSize: '14px',
  border: 'none',
  borderRadius: '4px',
  cursor: 'pointer',
};

const cancelButtonStyle = {
  backgroundColor: '#f44336',
  color: 'white',
  padding: '10px 20px',
  fontSize: '14px',
  border: 'none',
  borderRadius: '4px',
  cursor: 'pointer',
};

const listHeaderStyle = {
  fontSize: '20px',
  textAlign: 'center',
  marginTop: '40px',
};

const tableStyle = {
  width: '100%',
  borderCollapse: 'collapse',
  marginTop: '20px',
  border: '1px solid #ddd', // Adding border around the table
};

const tableHeaderStyle = {
  backgroundColor: '#007bff',
  color: 'white',
  padding: '12px',
  textAlign: 'left',
  border: '1px solid #ddd', // Adding border for header cells
};

const tableCellStyle = {
  padding: '12px',
  textAlign: 'left',
  border: '1px solid #ddd', // Adding border for table cells
};

const tableRowStyle = {
  backgroundColor: '#f9f9f9',
};

const updateButtonStyle = {
  backgroundColor: '#4caf50',
  color: 'white',
  padding: '6px 12px',
  fontSize: '14px',
  border: 'none',
  borderRadius: '4px',
  cursor: 'pointer',
  marginRight: '10px',
};

const activateButtonStyle = {
  backgroundColor: '#4caf50',
  color: 'white',
  padding: '6px 12px',
  fontSize: '14px',
  border: 'none',
  borderRadius: '4px',
  cursor: 'pointer',
};

const deactivateButtonStyle = {
  backgroundColor: '#f44336',
  color: 'white',
  padding: '6px 12px',
  fontSize: '14px',
  border: 'none',
  borderRadius: '4px',
  cursor: 'pointer',
};

export default CategoryManagement;
